/**
 * Travel Report Reducers
 */
import {
    TRAVELREPORT_ACTION,
    ALL_TRAVELREPORT,
 
 } from 'Actions/types';
 
 /**
  * initial auth user
  */
 const INIT_STATE = {
     travelreportlist:[],
     loading: false
 };
 
 export default (state = INIT_STATE, action) => {
     switch (action.type) {
        
         case TRAVELREPORT_ACTION:
             return { ...state, loading: true };
 
         case ALL_TRAVELREPORT:
             return { ...state, loading: false, travelreportlist: action.payload };  
             

        
         default: return { ...state };
     }
 }
 